export const INDUSTRIES = [
  'Retail',
  'Logistics',
  'Healthcare',
  'Finance',
  'Food & Beverage',
  'Technology',
  'Education',
  'Manufacturing',
  'Professional Services',
  'Real Estate',
  'Media & Entertainment',
  'Other',
] as const;

export type Industry = (typeof INDUSTRIES)[number];
